import { useEffect, useState } from "react";
import { BsLink45Deg } from "react-icons/bs";
import { AiOutlineQrcode } from "react-icons/ai";
import InputCopy from "../../../components/inputCopy";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import Loadingimg from "../../../statics/illustrations/sand-clock.svg";
import flyerENIMG from "../../../statics/flyer/sweepstakes/en.png";
import flyerESIMG from "../../../statics/flyer/sweepstakes/es.png";
import flyerENTWOIMG from "../../../statics/flyer/sweepstakes/en-two.png";
import flyerESTWOIMG from "../../../statics/flyer/sweepstakes/es-two.png";
import Error from "../../../components/error";
import { ErrorType } from "../../../store/errorType";
import { getLinks, getQr, getQrBW } from "../../../store/sweepstakes";
import CodeqrRaffle from "./qrContainer";
import FlyerRaffle from "./flyerRaffle";

const DetailRafflecampaign = () => {
  // const QA = process.env.REACT_APP_QA
  const dispatch = useAppDispatch();
  const { links, qr, qrbw, status: statusRaffle, id_brand } = useAppSelector((state) => state.sweepstakes);
  const { status, errorMessage, errorType } = useAppSelector(
    (state) => state.campaign
  );
  const [state, setstate] = useState<number>(0);

  useEffect(() => {
    dispatch(getLinks())
      .then((res) => {
        dispatch(getQr())
        dispatch(getQrBW())
           

        
      })
  }, [])

  if (statusRaffle === "getDetailCampaign_loading") {
    return (
      <div className="c-skeleton-detail-campaign">
        <div className="c-skeleton-detail-campaign__box-message">
          <img
            src={Loadingimg}
            alt="imagen loading"
            className="c-skeleton-detail-campaign__img"
          />
          <span className="c-skeleton-detail-campaign__message">
            We are now generating your PURLs!
          </span>
          <span className="c-skeleton-detail-campaign__message">
            This process may take up to 15 seconds.
          </span>
          <span className="c-skeleton-detail-campaign__message">
            Please do not refresh the page
          </span>
        </div>
      </div>
    );
  }

  if (status === "getDetailCampaign_rejected") {
    return (
      <>
        {errorType === ErrorType.ERROR_SERVER && (
          <Error type="error" message={errorMessage} />
        )}
        {errorType === ErrorType.ERROR_PERMISSION && (
          <Error type="problem" message={errorMessage} />
        )}
      </>
    );
  }
  return (
    <div className="c-detail-campaign">
      <div className="c-detail-campaign__tabs">
        <span
          className={`c-detail-campaign__tab ${state === 0 && `c-detail-campaign__tab--active`
            }`}
          onClick={() => setstate(0)}
        >
          <BsLink45Deg />
          <span className="c-detail-campaign__text">Links</span>
        </span>
        <span
          className={`c-detail-campaign__tab ${state === 3 && `c-detail-campaign__tab--active`
            }`}
          onClick={() => setstate(3)}
        >
          <AiOutlineQrcode />
          <span className="c-detail-campaign__text">QR Code</span>
        </span>
      </div>

      <div className="c-detail-campaign__content">
        {state === 0 && (
          <>
            {/* <InputCopy text="Link" value={`${detail.link}?utm_medium=long_link`} />
            <InputCopy text="Short Link (Preferred)" value={detail.short_link} /> */}
            <InputCopy text="Link" value={links.long_link} />
            <InputCopy text=" Short Link" value={links.short_link} />
          </>
        )}
        {state === 3 && (
          <>
            <div className="c-detail-campaign__title">
              QR Code, Flyers or Business Card Image
            </div>
            <div className="c-detail-campaign__subtitle">
              Download or Print: QR Code, Flyers or Business Card Image
            </div>
            <div className="c-detail-campaign__title-section">QR Code</div>
            <div className="c-code-qr">
              <CodeqrRaffle
                url={qr.img}
                name='Color QR Code'
              />
              <CodeqrRaffle
                url={qrbw.pdf}
                name='B&W QR Code'
              />
            </div>
            <hr className="c-detail-campaign__line" />
            <div className="c-detail-campaign__title-section">
              QR Code Flyer
            </div>
            <div className="c-flyers">
              <FlyerRaffle
                url='/api/purls-sweepstakes/flyer/en/one'
                id_brand={id_brand}
                title='QR Code Flyer English'
                name='Flyer_ENG_Full_Page_Color'
                image={flyerENIMG}
              />
              <FlyerRaffle
                url='/api/purls-sweepstakes/flyer/en/two'
                id_brand={id_brand}
                title='QR Code Flyer English'
                name='Flyer_ENG_Double_Page_Color'
                image={flyerENTWOIMG}
              />
            </div>
            <div className="c-flyers">
              <FlyerRaffle
                url='/api/purls-sweepstakes/flyer/es/one'
                id_brand={id_brand}
                title='QR Code Flyer Spanish'
                name='Flyer_SPA_Full_Page_Color'
                image={flyerESIMG}
              />
              <FlyerRaffle
                url='/api/purls-sweepstakes/flyer/es/two'
                id_brand={id_brand}
                title='QR Code Flyer Spanish'
                name='Flyer_SPA_Double_Page_Color'
                image={flyerESTWOIMG}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DetailRafflecampaign;
